import { ComparisonOperators } from '@contentsquare/fov-constants';
export const resolutionCondition = {
    id: 'resolution',
    category: 'technology',
    value: {
        operatorValues: [
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_IS' },
            { value: ComparisonOperators.MATCH_NOT_EQUALS, label: 'CONDITION_SELECT_IS_NOT' },
        ],
        resolutionValues: [
            {
                mobileAndSmartphone: [
                    {
                        value: '320x480',
                        label: '320×480 (iPhone 3G, Samsung Galaxy Ace)',
                    },
                    {
                        value: '320x568',
                        label: '320x568 (iPhone 5)',
                    },
                    {
                        value: '360×640',
                        label: '360×640 (Samsung Galaxy S7)',
                    },
                    {
                        value: '360×740',
                        label: '360×740 (Samsung Galaxy S8)',
                    },
                    {
                        value: '375×667',
                        label: '375×667 (iPhone 8, 7, 6/6S)',
                    },
                    {
                        value: '375×812',
                        label: '375×812 (iPhone X)',
                    },
                    {
                        value: '412×732',
                        label: '412×732 (Nexus 6P)',
                    },
                    {
                        value: '414x736',
                        label: '414×736 (iPhone Plus)',
                    },
                    {
                        value: '480x854',
                        label: '480×854 (LG G5, Samsung Galaxy N5)',
                    },
                    {
                        value: '540x960',
                        label: '540x960 (Sony Xperia P, HTC One S)',
                    },
                ],
            },
            {
                tabletAndNotebook: [
                    {
                        value: '1024x600',
                        label: '1024×600 (Basic notebook)',
                    },
                    {
                        value: '1024x768',
                        label: '1024×768 (Ipad, common tablet)',
                    },
                    {
                        value: '1280x720',
                        label: '1280×720 (Samsung Galaxy S III)',
                    },
                    {
                        value: '1280x800',
                        label: '1280×800 (Samsung Galaxy Tab, Acer Iconia)',
                    },
                ],
            },
            {
                monitorAndScreen: [
                    {
                        value: '800x600',
                        label: '800×600 (4:3 SVGA)',
                    },
                    {
                        value: '1280x1024',
                        label: '1280×1024 (5:4 SXGA)',
                    },
                    {
                        value: '1360x768',
                        label: '1360×768 (16:9 WXGA)',
                    },
                    {
                        value: '1366x768',
                        label: '1366×768 (16:9 WXGA)',
                    },
                    {
                        value: '1440x900',
                        label: '1440×900 (16:10 WXGA+, WSXGA)',
                    },
                    {
                        value: '1600x900',
                        label: '1600x900 (16:9 HD+)',
                    },
                    {
                        value: '1680x945',
                        label: '1680x945',
                    },
                    {
                        value: '1680x1050',
                        label: '1680×1050 (16:10 WSXGA+)',
                    },
                    {
                        value: '1920x1080',
                        label: '1920×1080 (16:9 FHD)',
                    },
                    {
                        value: '1920x1200',
                        label: '1920×1200 (16:9 WUXGA)',
                    },
                    {
                        value: '2436x1125',
                        label: '2436×1125',
                    },
                    {
                        value: '2560x1440',
                        label: '2560×1440 (16:9 WQHD)',
                    },
                ],
            },
        ],
    },
};
//# sourceMappingURL=resolution-condition.value.js.map